export default __webpack_public_path__ + "static/media/a001-ransomware-04.9559e7b3.png";